var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrueMatchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(-34.525 -35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 84,
    height: 84,
    rx: 10,
    transform: "translate(34.525 35)",
    fill: "#02bc77",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M520.13,268.663a2.788,2.788,0,0,1-.8-2.108c.032-5.688.017-11.377.015-17.065,0-3.435-1.705-5.138-5.134-5.142-1.657,0-3.315,0-5.07,0a3.613,3.613,0,0,0-2.386-4.116H491.09a3.552,3.552,0,0,0-2.31,4.035c-.383.03-.69.076-1,.078-1.629.007-3.261-.019-4.89.013a4.317,4.317,0,0,0-4.277,3.961,13.857,13.857,0,0,0-.043,1.412q0,16.948,0,33.9c0,3.278.674,4.314,3.6,5.545h30.454a29.033,29.033,0,0,0,5.084-1.982A12.068,12.068,0,0,0,520.13,268.663Zm-27.217-24.3h12.064v3.963H492.913Zm8.982,40.622a7.086,7.086,0,0,1-.8.1c-5.8.007-11.6-.011-17.4.022-.857.007-1.107-.237-1.105-1.105q.043-17.287,0-34.574c0-.77.183-1.122,1.024-1.1,1.662.048,3.324.013,5.064.013.063.635.078,1.1.161,1.564a2.9,2.9,0,0,0,2.941,2.521q7.12.026,14.242,0a3.051,3.051,0,0,0,3.1-2.874c.034-.354.006-.716.006-1.205,1.879,0,3.683,0,5.484,0,.742,0,.62.551.62,1.009q.007,5.381,0,10.763V265.3c-6.4-1.521-11.607.1-14.831,5.965C497.812,276,498.654,280.625,501.895,284.987Zm9.365.1a8.073,8.073,0,0,1-8.227-8.147,8.168,8.168,0,0,1,8.116-8.186,8.272,8.272,0,0,1,8.212,8.136A8.154,8.154,0,0,1,511.26,285.087Z",
    transform: "translate(-424.233 -187.792)",
    fill: "#02bc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M505.776,290.411l.318,0h.146c-.05,0-.1,0-.146,0C505.988,290.407,505.883,290.409,505.776,290.411Zm-1.346.009c.289.009.579.006.87,0C505.009,290.424,504.719,290.429,504.43,290.42Z",
    transform: "translate(-439.591 -217.593)",
    fill: "#02bc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M512.873,302.537a1.952,1.952,0,0,1-2.129,2.071q-4.947.029-9.9,0a2,2,0,1,1-.019-3.986c1.668-.021,3.335-.006,5-.006,1.632,0,3.261-.013,4.893,0C512.078,300.638,512.847,301.342,512.873,302.537Z",
    transform: "translate(-436.173 -223.653)",
    fill: "#02bc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M540.953,282.412c.013,1.271-.8,2.025-2.271,2.053-1.266.024-2.534,0-3.8,0s-2.534.017-3.8,0a2.051,2.051,0,1,1,.05-4.061q3.749-.023,7.5,0C540.072,280.414,540.938,281.183,540.953,282.412Z",
    transform: "translate(-454.046 -211.645)",
    fill: "#02bc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M505.888,322.639a2.1,2.1,0,0,1-2.356,2c-1.268.013-2.537,0-3.8,0s-2.536.017-3.8,0a1.978,1.978,0,0,1-2.217-1.995,2.021,2.021,0,0,1,2.269-2.062q3.8-.026,7.6,0A2.083,2.083,0,0,1,505.888,322.639Z",
    transform: "translate(-433.224 -235.507)",
    fill: "#02bc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M506.762,282.365a1.92,1.92,0,0,1-1.912,2.064c-.27.022-.54.028-.812.028q-.267,0-.535-.007l-.119,0c-.139,0-.277-.007-.416-.007-.048,0-.1,0-.144,0h-.146l-.318,0-.476.009c-.292.007-.581.009-.87,0-.133,0-.266-.011-.4-.022a1.988,1.988,0,0,1-1.936-2.064,1.962,1.962,0,0,1,1.932-1.96c1.407-.065,2.823-.063,4.233,0A1.933,1.933,0,0,1,506.762,282.365Z",
    transform: "translate(-436.177 -211.623)",
    fill: "#02bc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M558.335,324.2q-1.893,1.945-3.839,3.837a2.013,2.013,0,0,1-3.063-.026c-.6-.574-1.19-1.168-1.764-1.768a2.063,2.063,0,0,1-.165-2.989,2.113,2.113,0,0,1,3.006.12c.135.117.263.241.533.489.848-.877,1.633-1.725,2.46-2.537a1.975,1.975,0,0,1,2.976-.122A2.056,2.056,0,0,1,558.335,324.2Z",
    transform: "translate(-466.026 -235.514)",
    fill: "#02bc77"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueMatchIcon);
export default __webpack_public_path__ + "static/media/TrueMatchIcon.26fb6246d739cc78945df09d0c92fab8.svg";
export { ForwardRef as ReactComponent };